import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux'
import { LeftArrowSvg, RightArrowSvg } from 'components/icons';
import { HoverableIcon } from 'atoms';

export default ({ contentWrapper: ContentWrapper, outerWrapper: Wrapper, width, height, isOpen, close, displayState, canHover, onDropFiles, hasNext, hasPrev, onNext, onPrev }) => {
  const modal = (props) => {
    if (!isOpen(props)) return null;
    const wrapperRef = useRef(null);

    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
      function handleClickOutside(event) {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          close(props);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [wrapperRef]);

    const onDrop = (event) => {
      stopEvent(event);
      const { files } = event.dataTransfer;
      onDropFiles({ ...props, files })
      setIsHovered(false);
    }

    const onDragOver = (event) => {
      stopEvent(event);
      setIsHovered(true);
    }

    const onDragLeave = (event) => {
      stopEvent(event);
      setIsHovered(false);
    }

    const stopEvent = event => {
      event.preventDefault();
      event.stopPropagation();
    };

    const onClickPrev = () => {
      onPrev?.(props)
    }

    const onClickNext = () => {
      onNext?.(props)
    }

    return (
      <Wrapper>
        {onPrev &&
          <div style={{ width: 41 }}>
            {hasPrev(props) && <HoverableIcon onClick={onClickPrev} color='#FFFFFF' hoverColor={window?.settings?.primary_color ?? '#1DBD6B'} width={41} height={41} Icon={LeftArrowSvg} />}
          </div>
        }
        <ContentWrapper
          background={props.background}
          ref={wrapperRef}
          width={width}
          height={height}
          displayState={displayState?.(props)}
          isHovered={isHovered}
          onDrop={canHover?.(props) ? onDrop : () => { }}
          onDragLeave={canHover?.(props) ? onDragLeave : () => { }}
          onDragOver={canHover?.(props) ? onDragOver : () => { }}
        >
          {props.children}
        </ContentWrapper>
        {onNext &&
          <div style={{ width: 41 }}>
            {hasNext(props) && <HoverableIcon onClick={onClickNext} color='#FFFFFF' hoverColor={window?.settings?.primary_color ?? '#1DBD6B'} width={41} height={41} Icon={RightArrowSvg} />}
          </div>
        }
      </Wrapper>
    );
  }

  return connect(s => s)(modal)
}